import { List } from 'antd'

import TotalCard from 'atom/cards/TotalCard'
import { ListCardWrapper } from 'atom/list'

import { Financial } from 'models/transaction'
import { formatPrice, formatSecondsToMinutes } from 'helpers/number-format'
import { useFinancialTranslation } from 'hooks/translation/useFinancialTranslation'

interface FinancialProps {
  financial: Financial
}

const TransactionPanelTotal: React.FC<FinancialProps> = ({ financial }) => {
  const {
    taxText,
    subTotalText,
    totalText,
    localTaxText,
    loiteringFeeText,
    loiteringDurationText,
    chargingFeeText,
    flatFeeText,
    guestFeeText,
  } = useFinancialTranslation()

  const {
    tax,
    subtotal,
    total,
    currency,
    localTax,
    loiteringFeeCents,
    loiteringDuration,
    chargingFeeCents,
    flatFeeCents,
    guestFeeCents,
  } = financial
  console.log(financial)
  return (
    <ListCardWrapper>
      <TotalCard>
        <List.Item
          actions={[<span className="heading-06-regular-td">{formatPrice(chargingFeeCents / 100, currency)}</span>]}
        >
          <List.Item.Meta title={chargingFeeText} />
        </List.Item>
        {!!(guestFeeCents && guestFeeCents > 0) && (
          <List.Item
            actions={[<span className="heading-06-regular-td">{formatPrice(guestFeeCents / 100, currency)}</span>]}
          >
            <List.Item.Meta title={guestFeeText} />
          </List.Item>
        )}
        {!!(flatFeeCents && flatFeeCents > 0) && (
          <List.Item
            actions={[<span className="heading-06-regular-td">{formatPrice(flatFeeCents / 100, currency)}</span>]}
          >
            <List.Item.Meta title={flatFeeText} />
          </List.Item>
        )}
        {!!(loiteringDuration && loiteringDuration > 0) && (
          <List.Item
            actions={[<span className="heading-06-regular-td">{formatSecondsToMinutes(loiteringDuration)}</span>]}
          >
            <List.Item.Meta title={loiteringDurationText} />
          </List.Item>
        )}
        {!!(loiteringFeeCents && loiteringFeeCents > 0) && (
          <List.Item
            actions={[<span className="heading-06-regular-td">{formatPrice(loiteringFeeCents / 100, currency)}</span>]}
          >
            <List.Item.Meta title={loiteringFeeText} />
          </List.Item>
        )}
        <List.Item
          className="showBorderTop"
          actions={[<span className="heading-06-regular-td">{formatPrice(subtotal / 100, currency)}</span>]}
        >
          <List.Item.Meta title={subTotalText} />
        </List.Item>
        {!!(localTax && localTax > 0) && (
          <List.Item actions={[<span className="heading-06-regular-td">{formatPrice(localTax / 100, currency)}</span>]}>
            <List.Item.Meta title={localTaxText} />
          </List.Item>
        )}
        {financial.taxDetails && financial.taxDetails.length > 0 && (
          financial.taxDetails.map((taxDetail, index) => (
            <List.Item
              key={index}
              actions={[<span className="heading-06-regular-td">{formatPrice(taxDetail.taxAmount / 100, currency)}</span>]}
            >
              <List.Item.Meta 
                title={
                  <div>
                    <div>{taxDetail.taxDisplayName || taxText}</div>
                    {taxDetail.taxDisplayNote && (
                      <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
                        {taxDetail.taxDisplayNote}
                      </div>
                    )}
                  </div>
                }
              />
            </List.Item>
          ))
        )}
        <List.Item actions={[<span className="heading-06-regular-td">{formatPrice(tax / 100, currency)}</span>]}>
          <List.Item.Meta title={taxText} />
        </List.Item>
        <List.Item
          className="showBorderTop"
          actions={[<span className="paragraph-03-bold">{formatPrice(total / 100, currency)}</span>]}
        >
          <List.Item.Meta title={totalText} />
        </List.Item>
      </TotalCard>
    </ListCardWrapper>
  )
}

export default TransactionPanelTotal
